import { CallDB } from "../../lib/ddb";
import { AuthConstant } from "../reducers";

const Login = () => async (dispatch) => {
	dispatch({ type: AuthConstant.SET_AUTH, item: { _id: "dummy_id" } });
};

const Logout = () => async (dispatch) => {
	dispatch({ type: AuthConstant.CLEAR_AUTH });
};


const GetGroupInfo = (groupId) => async (dispatch) => {
	if (!groupId) {
		dispatch({ type: AuthConstant.SET_GROUP_LOADING, bool: false });
		return;
	}
	dispatch({ type: AuthConstant.SET_GROUP_LOADING, bool: true });
	try {
		const payload = {
			type: "get",
			params: {
				TableName: "rayteams-group",
				Key: {
					_id: groupId,
					sk: "info"
				},
				ProjectionExpression: "#_id, #sk, #name, #logo, #tel, #address",
				ExpressionAttributeNames: {
					"#_id": "_id",
					"#sk": "sk",
					"#name": "name",
					"#logo": "logo",
					"#tel": "tel",
					"#address": "address",
				}
			}
		};
		const groupRet = await CallDB(payload);
		if (groupRet?._id === groupId) {
			dispatch({ type: AuthConstant.SET_GROUP, item: groupRet });
		}
		return groupRet;
	} catch (error) {
		console.log("ERROR[GetGroupInfo]", error?.response?.data || error?.toString());
	} finally {
		dispatch({ type: AuthConstant.SET_GROUP_LOADING, bool: false });
	}
	return null;
};

export const AuthAction = {
	Login,
	Logout,
	GetGroupInfo,
};
